
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2018 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Fide Chess <span>Competition</span></h2>
        </div>
        <div class="gall-ery">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>Fide Chess Competition 2018</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="https://photos.app.goo.gl/P1tGMifjiDIIzmcf1" target="_blank"
                    class="cmn-button"><span>
                            View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fidechess18_1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fidechess18_1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fidechess18_1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/g3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>RESULT</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="result" class="cmn-button"><span>
                            View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <iframe style="width: 100%; height: 400px;"
                src="https://drive.google.com/file/d/1Iujgd7-fk0LVtJVXT1m6o1gHI96vhJip/preview"></iframe>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                        <h4>MEDIA COVERAGE</h4>
                    </div>
                </div>
                <div class="col-md-4 text-end">
                    <a href="media#media_fidechess" class="cmn-button"><span>
                            View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <iframe style="width: 100%; height: 400px;"
                src="https://drive.google.com/file/d/19Zw_2sCu4AU2dyVtbwseO0o2O9WVIrYg/preview"></iframe>
        </div>
    </div>
</section>
